window.$ = window.jQuery


require('./vendor/select2/js/select2.min.js')
require('./vendor/select2/css/select2.min.css')
require('./scss/style.scss')
require('./js/script.js')
require('./vendor/numberAnimate.js')
